ApiPromise = require 'network/api-promise'
MemberFeatures = require 'data/member-features'
Organization = require 'models/organization'
OrgFeatures = require 'data/org-features'
Promise = require 'bluebird'

getProductNumber = (model, product) ->
  if model instanceof Organization
    OrgFeatures.getProductNumber(product)
  else
    MemberFeatures.getProductNumber(product)

url = (model, paths...) ->
  [model.urlRoot, model.id, 'paidAccount', paths...].join('/')

PaidAccount = module.exports =
  changeProduct: (model, newProduct) ->
    productNumber = getProductNumber(model, newProduct)

    ApiPromise
      url: url(model, 'products')
      type: 'POST'
      data:
        products: [productNumber]

  cancel: (model) ->
    ApiPromise
      url: url(model, 'cancel')
      type: 'POST'

  renew: (model) ->
    PaidAccount.changeProduct(model, model.get('paidAccount').products[0])

  reactivate: (model, newProduct) ->
    productNumber = getProductNumber(model, newProduct)

    ApiPromise
      url: url(model, 'reactivate')
      type: 'POST'
      data:
        products: [productNumber]

  createAccount: (model, data) ->
    ApiPromise
      url: url(model)
      data: data
      type: 'POST'

  changeCreditCard: (model, data) ->
    ApiPromise
      url: url(model, 'creditCard')
      data: data
      type: 'POST'

  changeInvoiceDetails: (model, data) ->
    ApiPromise
      method: 'POST'
      url: url(model, 'invoice')
      data: data





// WEBPACK FOOTER //
// ./app/scripts/network/paid-account.coffee